import { Col } from "react-bootstrap";
import Drawer from "../../_metronic/layout/components/drawer/Drawer";
import Can from "../modules/Auth/Can";
import { useSubheader } from "../../_metronic/layout";
import NotificationAdminPage from "../sustell_15/components/notifications/admin/NotificationAdminPage";
import { useIntl } from "../../_metronic/i18n/customUseIntl";
import { Notifications } from "../modules/notifications/Notifications";
import featureFlags from "../sustell_15/utils/featureFlags";

const NotificationPage = () => {
  const intl = useIntl();
  const subheader = useSubheader();

  if (Can("access", "Admin pages")) {
    subheader.setTitle(intl.formatMessage({ id: "NOTIFICATIONS" }));
  }

  return Can("access", "Admin pages") ? (
    <Drawer>
      <Col>
        {featureFlags.notifications ? (
          <NotificationAdminPage category="Notification" />
        ) : (
          <Notifications />
        )}
      </Col>
    </Drawer>
  ) : (
    <></>
  );
};

export default NotificationPage;
